import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';

import CommentPopup from 'components/CommentPopup';
import Footer from 'components/Footer';
import Head from 'components/Head';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';
import WebpBlogImg from 'components/WebpBlogImg';
import { onAuthStateChanged } from 'firebase/auth';
import { fetchAppLaunch } from 'functions/appLaunch';
import { httpCall } from 'functions/httpAction';
import _ from 'lodash';
import useSWR from 'swr';
import { firebaseAuth } from 'utils/firebaseConfig';
import { swrSorraAPIFetcher } from 'utils/wpApi';
export default function ProductDetailReviews() {
  const router = useRouter();
  const { itemID } = router.query;
  const [filterState, setFilterState] = useState(-10);

  //from AppLaunch API
  const [arrNotificationState, setArrNotificationState] = useState(null);
  const [arrStoresState, setArrStoresState] = useState(null);
  const [arrProductOriginsState, setArrProductOriginsState] = useState(null);
  const [arrCategoryState, setArrCategoryState] = useState([]);
  const [arrSearchSkinProblemState, setArrSearchSkinProblemState] = useState(
    []
  );
  const [arrFactorTypesState, setArrFactorTypesState] = useState([]);
  const [arrBannerState, setArrBannerState] = useState([]);
  const [arrReviewSourcesState, setArrReviewSourcesState] = useState([]);
  const [arrIngridentSafetyState, setArrIngridentSafetyState] = useState([]);
  const [arrCategoryNameState, setArrCategoryNameState] = useState('');
  // const [arrIngridentsFeatureState, setArrIngridentsFeatureState] = useState([]);

  //from Product API
  const [productNameState, setProductNameState] = useState('');
  const [productBrandState, setProductBrandState] = useState({});
  const [productImageState, setProductImageState] = useState([]);
  const [productRatingState, setProductRatingState] = useState(null);
  const [productReviewCountState, setProductReviewCountState] = useState(0);
  const [
    arrProductReviewFactorOverviewState,
    setArrProductReviewFactorOverviewState,
  ] = useState([]);
  const [arrProductReviewsState, setArrProductReviewsState] = useState([]);

  const [isUserLoggedIn, setIsUserLoggeedIn] = useState(false);

  const [firUser, setFirUser] = useState(null);

  const [isCommentModalShow, setIsCommentModalShow] = useState(false);

  function appLaunch() {
    fetchAppLaunch().then(async ([success, error, data]) => {
      if (data.notifications) {
        setArrNotificationState(data.notifications);
      }

      if (data.stores) {
        setArrStoresState(data.stores);
      }

      if (data.product_origins) {
        setArrProductOriginsState(data.product_origins);
      }

      if (data.category_tree) {
        setArrCategoryState(data.category_tree);
      }

      if (data.search_skin_problem_keywords) {
        setArrSearchSkinProblemState(data.search_skin_problem_keywords);
      }

      if (data.factor_types) {
        setArrFactorTypesState(data.factor_types);
      }

      if (data.review_sources) {
        setArrReviewSourcesState(data.review_sources);
      }

      if (data.ingredient_safeties) {
        setArrIngridentSafetyState(data.ingredient_safeties);
      }

      // if (data.ingredient_features) {
      //   setArrIngridentsFeatureState(data.ingredient_features);
      // }

      fetchBlogContent();
    });
  }

  async function checkSignIn() {
    onAuthStateChanged(firebaseAuth, (user) => {
      if (user) {
        setIsUserLoggeedIn(true);
        setFirUser(user);
      } else {
        setIsUserLoggeedIn(false);
        setFirUser(null);
      }
    });
  }

  async function fetchBlogContent() {
    const token = firUser ? firUser.accessToken : null;
    try {
      const [success, error, statusCode, data] = await httpCall(
        'get',
        process.env.NEXT_PUBLIC_API_HOST +
          '/api/v2/product/' +
          router.query.itemID +
          '/overview',
        token,
        null
      );

      if (success == true) {
        if (data.name) {
          setProductNameState(data.name);
        }

        if (data.brand) {
          setProductBrandState(data.brand);
        }

        if (data.images) {
          setProductImageState(data.images);
        }

        if (data.rating != null) {
          setProductRatingState(data.rating);
        }

        if (data.review_count != null) {
          setProductReviewCountState(data.review_count);
        }

        if (data.review_factor_overview != null) {
          var arrProductReviewFactorOverviewTmp = [];

          data.review_factor_overview.forEach((element) => {
            arrProductReviewFactorOverviewTmp.push(element);
          });

          setArrProductReviewFactorOverviewState(
            arrProductReviewFactorOverviewTmp
          );
        }

        if (data.reviews != null) {
          var arrProductReviewsTmp = [];

          data.reviews.forEach((element) => {
            arrProductReviewsTmp.push(element);
          });

          setArrProductReviewsState(arrProductReviewsTmp);
        }

        if (data.second_categories != null) {
          const category = _.head(data.second_categories)
            ? _.head(data.second_categories).name
            : null;
          setArrCategoryNameState(category);
        }
        // calculateRating()
        // loadBlockCommentsState();
      } else {
        console.log('api error', errorCall);
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  function RelatedArticle(props) {
    const { posts, itemID } = props;

    return (
      <div className="mx-[16px] my-[24px] gap-x-6 gap-y-6 px-4 lg:mx-0 lg:my-[40px] lg:grid-cols-4 lg:gap-y-0 lg:px-0">
        <MaxWidthContainer>
          <div className="w-full" id="related-article">
            <div className="text-2xl font-bold text-sorra-gray-900">
              相關文章
            </div>
            <div className="mt-[24px] flex flex-row">
              <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
                {_.filter(posts, (post) => {
                  const ogImage = post.image_url?.url || '';
                  return ogImage != '' > 0;
                }).map((posts, idx) => {
                  const { id, title, url, category_name, image_url } = posts;
                  const imageUrl = image_url?.url || '';
                  const categoryName = category_name || '';

                  return (
                    <a key={`${idx}:${id}`} className="block" href={url}>
                      <WebpBlogImg
                        className="aspect-square w-full rounded-xl object-cover"
                        src={imageUrl}
                      ></WebpBlogImg>
                      <div className="pt-6 text-sm text-sorra-gray-800">
                        {categoryName}
                      </div>
                      <div className="line-clamp-2 pt-1 text-lg font-medium text-sorra-gray-900">
                        {title.replaceAll('&amp;', '&')}
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </MaxWidthContainer>
      </div>
    );
  }

  const { data: posts, isLoading: isPostsLoading } = useSWR(
    arrCategoryNameState != ''
      ? '/v1/wordpress/posts?page=1&per_page=4&search=' + arrCategoryNameState
      : null,
    swrSorraAPIFetcher,
    { fallbackData: [] }
  );

  useEffect(() => {
    checkSignIn();
  }, []);

  useEffect(() => {
    if (router.query.itemID) {
      appLaunch();
    }
  }, [router.query]);

  useEffect(() => {
    fetchBlogContent();
  }, []);

  return (
    <div>
      <Head />

      <main>
        <Menubar
          props={{
            homeExtend: false,
            notifications: arrNotificationState,
            sourceUI: 'ProductDetailReviews',
          }}
        />

        <div
          className={
            'globals-centerContentsMargin' +
            (arrNotificationState?.length > 0 ? ' withNoti' : '')
          }
          style={{ marginBottom: 0 + 'px' }}
        >
          <div className="">
            <MaxWidthContainer className="flex p-4">
              <img src="/svgs/chevron-left.svg"></img>
              <a
                href={'/product/' + itemID}
                className="pl-[8px] font-medium text-sorra-gray-900"
              >
                返回
              </a>
            </MaxWidthContainer>
          </div>
        </div>

        <div className="mb-[24px] mt-[12px] lg:mb-[40px] lg:mt-[40px]">
          <MaxWidthContainer className="flex items-center px-4">
            <div className="w-[80px] lg:w-[112px]">
              <div className="h-[80px] w-[80px] rounded-lg bg-[#F5F5F5] lg:h-[112px] lg:w-[112px] lg:p-[12px] lg:p-[4px]">
                <img src={productImageState[0]?.url}></img>
              </div>
            </div>
            <div className="grow pl-[16px] lg:pl-[24px]">
              <div className="text-sm font-normal text-sorra-gray-800 lg:text-base">
                {productBrandState?.name}
              </div>
              <div className="pt-[4px] text-lg font-medium text-sorra-gray-900 lg:text-2xl">
                {productNameState}
              </div>
            </div>
          </MaxWidthContainer>
        </div>

        <div className="h-[1px] w-full bg-[#E7E7E7]"></div>
        <RelatedArticle posts={posts} itemID={itemID} />
      </main>

      <CommentPopup
        externalPopupShown={isCommentModalShow}
        externalProductID={null}
        externalProductBrandName={null}
        externalProductName={null}
        setExternalPopupShown={setIsCommentModalShow}
      />

      <Footer />

      <MobileTabBar props={{ highlighted: 'home' }} />
    </div>
  );
}
